
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M24.484 21.69H5.496a2.759 2.759 0 01-2.759-2.753V6.753A2.757 2.757 0 015.492 4h18.987a2.767 2.767 0 012.763 2.753v12.184a2.759 2.759 0 01-2.758 2.753zM5.492 6.753v12.184h18.987V6.753zM27.594 25.988H2.377a1.377 1.377 0 110-2.753h25.217a1.377 1.377 0 110 2.753z"}})])])
          )
        }
      }
    